import { createStore } from 'vuex'
import {get_routes} from "@/service/api";

export default createStore({
  state: {
    component_rows: 2,
    current_tag: 'All',
    current_rhino_version:"9",
    has_add_routes: false,
    routes: [],
    highlightedIconId: null,
    // 从搜索框点进来的组件 id。与 highlightedIconId 的区别是：后者表示
    // 「当前是哪个组件」，刷新页面后也该保持；这里只表示「这一次跳转是从搜索
    // 发起的」，用完即清，刷新后不该再触发聚焦动效，所以不写 localStorage。
    searchNavigationId: null,
    // 正在做聚焦动效的图标 id，由图标区控制、动效结束即清空。
    // 放 Vuex 而不是 props，是为了省掉 GHSubCategory -> GHSubGroup 的透传：
    // 图标组件直接 mapState 读它，和读 highlightedIconId 的方式一致。
    focusIconId: null
  },
  getters:{
    // 返回路由数据
    get_routes: state => {
      return state.routes
    },
  },
  mutations: {
    set_routes(state, routes){
      state.routes = routes
    },
    set_component_rows(state,rows){
      state.component_rows = rows
    },
    set_current_tag(state,tag){
      state.current_tag = tag;
    },
    set_current_rhino_version(state,version_str){
      state.current_rhino_version = version_str;
    },
    setHighlightedIconId(state, id) {
      state.highlightedIconId = id;
    },
    setSearchNavigationId(state, id) {
      state.searchNavigationId = id;
    },
    setFocusIconId(state, id) {
      state.focusIconId = id;
    }
  },
  actions: {
    async update_routes(context){
      await get_routes().then(response => {
        context.commit("set_routes", response.data)
        context.state.has_add_routes = true
      }).catch(error => {
          console.error('从后端获取路由失败！', error);
      })
    },
    get_local_rows(context){
      let val = localStorage.getItem('component_rows')
      if (val !== null){
        context.commit("set_component_rows", Number(val))
      }
    },
    set_local_rows(context, rows){
      localStorage.setItem('component_rows', rows)
      context.commit("set_component_rows", rows)
    },
    // 从 localStorage 恢复用户上次选择的 Rhino 版本，没有记录时保留 state 里的默认值
    get_local_rhino_version(context){
      let val = localStorage.getItem('current_rhino_version')
      if (val !== null){
        context.commit("set_current_rhino_version", val)
      }
    },
    set_local_rhino_version(context, version_str){
      localStorage.setItem('current_rhino_version', version_str)
      context.commit("set_current_rhino_version", version_str)
    },
    updateHighlightedIconId({ commit }, id) {
      commit('setHighlightedIconId', id);
    },
    // 搜索跳转标记。只在点击搜索结果时调用，图标区据此决定要不要做聚焦动效
    markSearchNavigation({ commit }, id) {
      commit('setSearchNavigationId', id);
    },
    // 聚焦动效做完（或放弃）后清掉，避免下次无关的跳转又触发一次
    clearSearchNavigation({ commit }) {
      commit('setSearchNavigationId', null);
    },
    // 点亮/熄灭某个图标的聚焦光晕
    setFocusIcon({ commit }, id) {
      commit('setFocusIconId', id);
    }
  },
  modules: {
  }
})
